import {
    lazycreateAttachmentsFromRecentAttachments,
    AttachmentWellViewState,
} from 'owa-attachment-well-data';
import { ClientAttachmentId, MailboxInfo } from 'owa-client-ids';
import AttachmentId from 'owa-service/lib/contract/AttachmentId';
import { InfoBarHostViewState } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import ItemId from 'owa-service/lib/contract/ItemId';
import AttachmentType from 'owa-service/lib/contract/AttachmentType';
import { AttachmentPillData } from '../store/schema/AttachmentPillData';
import getRecentAttachments from './getRecentAttachments';

export default async function createAttachmentFromRecentAttachmentsPills(
    attachmentPillsData: AttachmentPillData[],
    onAttachmentCreation: (attachmentCreated: boolean, attachmentId?: AttachmentId) => void,
    itemId: ItemId,
    attachmentWell: AttachmentWellViewState,
    infoBar: InfoBarHostViewState,
    mailboxInfo: MailboxInfo
) {
    const recentAttachments: AttachmentType[] = getRecentAttachments(attachmentPillsData);

    if (recentAttachments) {
        const createAttachmentsFromRecentAttachments = await lazycreateAttachmentsFromRecentAttachments.import();
        createAttachmentsFromRecentAttachments(
            {
                ...itemId,
                mailboxInfo: mailboxInfo,
            },
            attachmentWell,
            recentAttachments,
            infoBar,
            (attachmentId: ClientAttachmentId) => {
                onAttachmentCreation(true /*attachmentCreated */, attachmentId);
            },
            () => {
                onAttachmentCreation(false /*attachmentCreated */);
            }
        );
    }
}
